import { useEffect } from "react";
import { ConfigProvider, App as AntdApp } from "antd";
import { AppRouter } from "./router";
import { antdTheme } from "./config";
import { useBettingPoolStatusStore } from "./stores";
import "./styles/index.css";

export function App() {
  const fetchStatuses = useBettingPoolStatusStore((state) => state.fetchStatuses);

  useEffect(() => {
    fetchStatuses();
  }, [fetchStatuses]);

  return (
    <ConfigProvider theme={antdTheme}>
      <AntdApp>
        <AppRouter />
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;
